import ArrowRightIcon from '@mui/icons-material/ArrowRight'
import MuiAccordion from '@mui/material/Accordion'
import MuiAccordionDetails from '@mui/material/AccordionDetails'
import MuiAccordionSummary from '@mui/material/AccordionSummary'
import { styled } from '@mui/material/styles'
import React from 'react'

const Accordion = styled((props: React.ComponentProps<typeof MuiAccordion>) => (
  <MuiAccordion defaultExpanded disableGutters elevation={0} {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.border.grey}`,
  boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.1)',
  '&:before': {
    display: 'none',
  },
  borderRadius: '6px',
}))

type AccordionSummaryCustomProps = {
  iconGap?: boolean
  disablePointer?: boolean
  withNewColors?: boolean
}

const StyledAccordionSummary = styled(MuiAccordionSummary, {
  shouldForwardProp: prop => prop !== 'iconGap' && prop !== 'disablePointer' && prop !== 'withNewColors',
})<AccordionSummaryCustomProps>(({ theme, iconGap = true, disablePointer = false, withNewColors = false }) => ({
  background: withNewColors ? theme.palette.background.header : theme.palette.background.accordion,
  '&:focus-within': {
    background: withNewColors ? theme.palette.background.header : theme.palette.background.accordion,
  },
  borderBottom: `1px solid ${theme.palette.border.grey}`,
  flexDirection: 'row-reverse',
  '&.MuiButtonBase-root:hover': {
    cursor: disablePointer ? 'default' : 'pointer',
  },
  '&.MuiButtonBase-root.Mui-expanded:hover': {
    cursor: disablePointer ? 'default' : 'pointer',
  },
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
  '& .MuiAccordionSummary-content.Mui-expanded': {
    margin: `12px 0 12px ${iconGap ? 8 : 0}px`,
  },
  '&.Mui-expanded': {
    minHeight: '48px',
    margin: 0,
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: iconGap ? theme.spacing(1) : 0,
  },
  borderRadius: '6px 6px 0px 0px',
}))

const AccordionSummary = (props: React.ComponentProps<typeof StyledAccordionSummary>) => (
  <StyledAccordionSummary expandIcon={<ArrowRightIcon color="disabled" />} {...props} />
)

const AccordionDetails = styled(MuiAccordionDetails)(() => ({
  padding: 0,
}))

export { Accordion, AccordionSummary, AccordionDetails }
